// Vehicle price list (Rockstar / FiveM). Prezzi in $.
export const VEHICLES = [
  { name: "Albany Alpha", price: 265000 },
  { name: "Albany Brigham", price: 749500 },
  { name: "Albany Buccaneer", price: 112500 },
  { name: "Albany Buccaneer Rider", price: 122500 },
  { name: "Albany Cavalcade", price: 120000 },
  { name: "Albany Cavalcade II", price: 97500 },
  { name: "Albany Cavalcade XL", price: 832500 },
  { name: "Albany Emperor", price: 71250 },
  { name: "Albany Franken Stange", price: 435000 },
  { name: "Albany Hermes", price: 2675000 },
  { name: "Albany Manana", price: 64000 },
  { name: "Albany Manana Custom", price: 120000 },
  { name: "Albany Roosevelt", price: 375000 },
  { name: "Albany Roosevelt Valor", price: 315000 },
  { name: "Albany V-STR", price: 400000 },
  { name: "Albany Virgo", price: 110000 },
  { name: "Albany Washington", price: 85000 },
  { name: "Annis 190Z", price: 390000 },
  { name: "Annis 300R", price: 280000 },
  { name: "Annis Bf Injection", price: 145000 },
  { name: "Annis Bifta", price: 127500 },
  { name: "Annis Blazer", price: 137500 },
  { name: "Annis Blazer Sport", price: 296250 },
  { name: "Annis Calico GTF", price: 195000 },
  { name: "Annis Diablous", price: 150000 },
  { name: "Annis Diablous Custom", price: 190000 },
  { name: "Annis Dubsta 6x6", price: 3170000 },
  { name: "Annis DR1", price: 1750000 },
  { name: "Annis Dune Buggy", price: 120000 },
  { name: "Annis Elegy Retro Custom", price: 725000 },
  { name: "Annis Elegy RH8", price: 750000 },
  { name: "Annis Enduro", price: 127500 },
  { name: "Annis Euros", price: 400000 },
  { name: "Annis Futo GTX", price: 195000 },
  { name: "Annis Hellion", price: 190000 },
  { name: "Annis Jester Racecar", price: 1050000 },
  { name: "Annis Jester RR", price: 1200000 },
  { name: "Annis Kanjo SJ", price: 715000 },
  { name: "Annis Postlude", price: 450000 },
  { name: "Annis Previon", price: 745000 },
  { name: "Annis RE-7B", price: 18000000 },
  { name: "Annis Remus", price: 240000 },
  { name: "Annis S80RR", price: 15250000 },
  { name: "Annis Sugoi", price: 425000 },
  { name: "Annis Vivanite", price: 802500 },
  { name: "Annis ZR350", price: 190000 },
  { name: "BF Club", price: 40000 },
  { name: "BF Raptor", price: 450000 },
  { name: "BF Surfer", price: 145000 },
  { name: "BF Surfer Custom", price: 75000 },
  { name: "BF Weevil", price: 95000 },
  { name: "BF Weevil Custom", price: 475000 },
  { name: "Benefactor BR8", price: 2000000 },
  { name: "Benefactor Dubsta", price: 100000 },
  { name: "Benefactor Dubsta Luxury", price: 247500 },
  { name: "Benefactor Feltzer", price: 485000 },
  { name: "Benefactor Glendale", price: 67000 },
  { name: "Benefactor Glendale Custom", price: 60000 },
  { name: "Benefactor Krieger", price: 16100000 },
  { name: "Benefactor LM87", price: 12750000 },
  { name: "Benefactor Panto", price: 66000 },
  { name: "Benefactor Schafter", price: 80000 },
  { name: "Benefactor Schafter LWB", price: 105000 },
  { name: "Benefactor Schafter V12", price: 175000 },
  { name: "Benefactor Schlagen GT", price: 800000 },
  { name: "Benefactor Schwartzer", price: 235000 },
  { name: "Benefactor Serrano", price: 240000 },
  { name: "Benefactor SM722", price: 625000 },
  { name: "Benefactor Stirling GT", price: 575000 },
  { name: "Benefactor Streiter", price: 200000 },
  { name: "Benefactor XLS", price: 135000 },
  { name: "Bike BMX", price: 20000 },
  { name: "Bike Cruiser", price: 30000 },
  { name: "Bike Endurex Race Bike", price: 15000 },
  { name: "Bike Fixter", price: 17500 },
  { name: "Bike Tri-Cycles Race Bike", price: 20000 },
  { name: "Bike Whippet Race Bike", price: 12500 },
  { name: "Bollokan Prairie", price: 150000 },
  { name: "Bravado Banshee", price: 280000 },
  { name: "Bravado Banshee 900R", price: 11000000 },
  { name: "Bravado Bison", price: 140000 },
  { name: "Bravado Buffalo", price: 93750 },
  { name: "Bravado Buffalo EVX", price: 1070000 },
  { name: "Bravado Buffalo S", price: 122500 },
  { name: "Bravado Dorado", price: 687500 },
  { name: "Bravado Gauntlet", price: 142500 },
  { name: "Bravado Gauntlet Classic Custom", price: 600000 },
  { name: "Bravado Gauntlet Hellfire", price: 400000 },
  { name: "Bravado Gresley", price: 125000 },
  { name: "Bravado Greenwood", price: 525000 },
  { name: "Bravado Hotring Hellfire", price: 905000 },
  { name: "Bravado Jester", price: 425000 },
  { name: "Bravado Lurcher", price: 105000 },
  { name: "Bravado Paradise", price: 145000 },
  { name: "Bravado Pißwasser Dominator", price: 250000 },
  { name: "Bravado Redwood Gauntlet", price: 350000 },
  { name: "Bravado Rumpo", price: 145000 },
  { name: "Bravado Rumpo Custom", price: 147500 },
  { name: "Bravado Verlierer", price: 452500 },
  { name: "Bravado Youga Classic", price: 272500 },
  { name: "Bravado Youga Classic 4x4", price: 125000 },
  { name: "Bravado Youga Custom", price: 475000 },
  { name: "Brute Armored Boxville", price: 225000 },
  { name: "Brute Biff", price: 500000 },
  { name: "Brute Bus", price: 325000 },
  { name: "Brute Boxville Go Postal", price: 225000 },
  { name: "Brute Boxville Humane Labs", price: 225000 },
  { name: "Brute Boxville LSDWP", price: 225000 },
  { name: "Brute Boxville (LSDS)", price: 237500 },
  { name: "Brute Airport Bus", price: 350000 },
  { name: "Brute Dashound", price: 375000 },
  { name: "Brute Rental Shuttle Bus", price: 300000 },
  { name: "Brute Stockade", price: 500000 },
  { name: "Brute Taco Truck", price: 225000 },
  { name: "Brute Tour Bus", price: 275000 },
  { name: "Brute Utility Truck (Cherry Picker)", price: 150000 },
  { name: "Brute Utility Truck (Contender)", price: 150000 },
  { name: "Brute Utility Truck (Van)", price: 150000 },
  { name: "Canis Freecrawler", price: 120000 },
  { name: "Canis Kamacho", price: 400000 },
  { name: "Canis Kalahari", price: 70000 },
  { name: "Canis Mesa", price: 60000 },
  { name: "Canis Mesa Merryweather", price: 750000 },
  { name: "Canis Seminole", price: 100000 },
  { name: "Canis Seminole Frontier", price: 90000 },
  { name: "Canis Terminus", price: 938750 },
  { name: "Cheval Fugitive", price: 100000 },
  { name: "Cheval Picador", price: 100000 },
  { name: "Cheval Surge", price: 100000 },
  { name: "Cheval Taipan", price: 14250000 },
  { name: "Classique Broadway", price: 100000 },
  { name: "Coil Cyclone", price: 20000000 },
  { name: "Coil Inductor", price: 45000 },
  { name: "Coil Junk Energy Inductor", price: 75000 },
  { name: "Coil Voltic", price: 11000000 },
  { name: "Declasse Asea", price: 62500 },
  { name: "Declasse Burrito", price: 140000 },
  { name: "Declasse Burrito Custom", price: 157500 },
  { name: "Declasse Draugur", price: 495000 },
  { name: "Declasse Drifter Tampa", price: 400000 },
  { name: "Declasse Granger", price: 110000 },
  { name: "Declasse Impaler", price: 475000 },
  { name: "Declasse Impaler LX", price: 732500 },
  { name: "Declasse Mamba", price: 700000 },
  { name: "Declasse Moonbeam", price: 115000 },
  { name: "Declasse Moonbeam Custom", price: 125000 },
  { name: "Declasse Premier", price: 60000 },
  { name: "Declasse Rancher XL", price: 120000 },
  { name: "Declasse Rhapsody", price: 50000 },
  { name: "Declasse Sabre GT Turbo", price: 115000 },
  { name: "Declasse Sabre GT Turbo Custom", price: 132500 },
  { name: "Declasse Stallion", price: 165000 },
  { name: "Declasse Stallion Burgershot", price: 200000 },
  { name: "Declasse Tahoma Coupe", price: 95000 },
  { name: "Declasse Tampa", price: 122500 },
  { name: "Declasse Tornado", price: 105000 },
  { name: "Declasse Tornado Convertible", price: 110000 },
  { name: "Declasse Tornado Custom", price: 110000 },
  { name: "Declasse Tulip", price: 400000 },
  { name: "Declasse Tulip M-100", price: 400000 },
  { name: "Declasse Vamos", price: 150000 },
  { name: "Declasse Vigero", price: 197500 },
  { name: "Declasse Vigero ZX", price: 525000 },
  { name: "Declasse Vigero ZX Convertible", price: 1147500 },
  { name: "Declasse Voodoo", price: 65000 },
  { name: "Declasse Walton L35", price: 835000 },
  { name: "Declasse Yosemite", price: 97500 },
  { name: "Declasse Yosemite Drift", price: 275000 },
  { name: "Declasse Yosemite Rancher", price: 2125000 },
  { name: "Dewbauchee Autarch", price: 16200000 },
  { name: "Dewbauchee Exemplar", price: 200000 },
  { name: "Dewbauchee JB 700", price: 1200000 },
  { name: "Dewbauchee Massacro", price: 550000 },
  { name: "Dewbauchee Massacro Racecar", price: 400000 },
  { name: "Dewbauchee Rapid GT", price: 430000 },
  { name: "Dewbauchee Rapid GT Classic", price: 450000 },
  { name: "Dewbauchee Rapid GT Convertible", price: 460000 },
  { name: "Dewbauchee Seven-70", price: 700000 },
  { name: "Dewbauchee Specter", price: 800000 },
  { name: "Dewbauchee Vagner", price: 8300000 },
  { name: "Dinka Blista", price: 65000 },
  { name: "Dinka Blista Compact", price: 94750 },
  { name: "Dinka Blista Go Go Monkey", price: 75000 },
  { name: "Dinka Blista Kanjo", price: 60000 },
  { name: "Dinka Double-T", price: 140000 },
  { name: "Dinka Enduro", price: 127500 },
  { name: "Dinka Jester", price: 661250 },
  { name: "Dinka Jester Classic", price: 425000 },
  { name: "Dinka Jester Racecar", price: 1050000 },
  { name: "Dinka Jester RR", price: 1200000 },
  { name: "Dinka Kanjo SJ", price: 715000 },
  { name: "Dinka Postlude", price: 450000 },
  { name: "Dinka Sugoi", price: 425000 },
  { name: "Dinka Thrust", price: 110000 },
  { name: "Dinka Verus", price: 100000 },
  { name: "Dinka Vindicator", price: 95000 },
  { name: "Dundreary Landstalker", price: 95000 },
  { name: "Dundreary Landstalker XL", price: 130000 },
  { name: "Dundreary Regina", price: 85000 },
  { name: "Dundreary Stretch", price: 250000 },
  { name: "Dundreary Virgo Classic", price: 105000 },
  { name: "Dundreary Virgo Custom Classic", price: 105000 },
  { name: "Emperor ETR1", price: 16000000 },
  { name: "Emperor Habanero", price: 100000 },
  { name: "Emperor Vectre", price: 400000 },
  { name: "Enus Cognoscenti", price: 112500 },
  { name: "Enus Cognoscenti 55", price: 110000 },
  { name: "Enus Cognoscenti Cabrio", price: 150000 },
  { name: "Enus Huntley S", price: 122500 },
  { name: "Enus Jubilee", price: 2425000 },
  { name: "Enus Stafford", price: 200000 },
  { name: "Enus Super Diamond", price: 85000 },
  { name: "Enus Windsor", price: 135000 },
  { name: "Enus Windsor Drop", price: 170000 },
  { name: "Fathom FR36", price: 1000500 },
  { name: "Gallivanter Baller", price: 110000 },
  { name: "Gallivanter Baller II", price: 175000 },
  { name: "Gallivanter Baller LE", price: 200000 },
  { name: "Gallivanter Baller LE LWB", price: 250000 },
  { name: "Gallivanter Baller ST", price: 725000 },
  { name: "Gallivanter Baller ST-D", price: 857500 },
  { name: "Grotti Bestia GTS", price: 235000 },
  { name: "Grotti Brioso 300", price: 60000 },
  { name: "Grotti Brioso 300 Widebody", price: 375000 },
  { name: "Grotti Brioso R/A", price: 95000 },
  { name: "Grotti Carbonizzare", price: 775000 },
  { name: "Grotti Cheetah", price: 15700000 },
  { name: "Grotti Cheetah Classic", price: 975000 },
  { name: "Grotti Furia", price: 16500000 },
  { name: "Grotti GT500", price: 650000 },
  { name: "Grotti Stinger", price: 197500 },
  { name: "Grotti Stinger GT", price: 350000 },
  { name: "Grotti Turismo Classic", price: 850000 },
  { name: "Grotti Turismo Omaggio", price: 19225000 },
  { name: "Grotti Turismo R", price: 12000000 },
  { name: "Grotti Visione", price: 3750000 },
  { name: "Grotti X80 Proto", price: 16750000 },
  { name: "Hijak Khamelion", price: 450000 },
  { name: "Hijak Ruston", price: 650000 },
  { name: "HVY Airtug", price: 150000 },
  { name: "HVY Cutter", price: 255000 },
  { name: "HVY Dock Handler", price: 300000 },
  { name: "HVY Docktug", price: 150000 },
  { name: "HVY Dozer", price: 350000 },
  { name: "HVY Dump Truck", price: 450000 },
  { name: "HVY Forklift", price: 150000 },
  { name: "HVY Mixer", price: 225000 },
  { name: "HVY Mixer II", price: 225000 },
  { name: "HVY Ripley", price: 150000 },
  { name: "I-Wagen Obey", price: 1250000 },
  { name: "Imponte Beater Dukes", price: 225000 },
  { name: "Imponte Dukes", price: 117500 },
  { name: "Imponte Nightshade", price: 350000 },
  { name: "Imponte Phoenix", price: 325000 },
  { name: "Imponte Ruiner", price: 145000 },
  { name: "Imponte Ruiner ZZ-8", price: 425000 },
  { name: "Invetero Coquette", price: 725000 },
  { name: "Invetero Coquette BlackFin", price: 900000 },
  { name: "Invetero Coquette Classic", price: 825000 },
  { name: "Invetero Coquette D10", price: 1100000 },
  { name: "Jacksheepe Lawn Mower", price: 150000 },
  { name: "Jobuilt Hauler", price: 500000 },
  { name: "Jobuilt Hauler Custom", price: 500000 },
  { name: "Jobuilt Phantom", price: 500000 },
  { name: "Jobuilt Phantom Custom", price: 550000 },
  { name: "Jobuilt Phantom Wedge", price: 500000 },
  { name: "Jobuilt Rubble", price: 300000 },
  { name: "Jobuilt Trashmaster", price: 300000 },
  { name: "Karin 190Z", price: 390000 },
  { name: "Karin Asterope", price: 55000 },
  { name: "Karin Asterope GZ", price: 2295000 },
  { name: "Karin BeeJay XL", price: 125000 },
  { name: "Karin Boor", price: 115000 },
  { name: "Karin Calico GTF", price: 195000 },
  { name: "Karin Dilettante", price: 75000 },
  { name: "Karin Dilettante Patrol", price: 60000 },
  { name: "Karin Everon", price: 300000 },
  { name: "Karin Everon Hotring", price: 400000 },
  { name: "Karin Futo", price: 87500 },
  { name: "Karin Futo GTX", price: 195000 },
  { name: "Karin Intruder", price: 56250 },
  { name: "Karin Kuruma", price: 360000 },
  { name: "Karin2 kuruma2", price: 360000 },
  { name: "Karin Penumbra", price: 110000 },
  { name: "Karin Penumbra FF", price: 150000 },
  { name: "Karin Previon", price: 745000 },
  { name: "Karin Sultan", price: 250000 },
  { name: "Karin Sultan Classic Custom", price: 280000 },
  { name: "Karin Sultan Custom", price: 275000 },
  { name: "Karin Sultan RS", price: 382500 },
  { name: "Karin Vivanite", price: 802500 },
  { name: "Lampadati Casco", price: 500000 },
  { name: "Lampadati Corsita", price: 450000 },
  { name: "Lampadati F620", price: 162500 },
  { name: "Lampadati Felon", price: 325000 },
  { name: "Lampadati Felon GT", price: 235000 },
  { name: "Lampadati Furore GT", price: 490000 },
  { name: "Lampadati Michelli GT", price: 150000 },
  { name: "Lampadati Novak", price: 350000 },
  { name: "Lampadati Pigalle", price: 460000 },
  { name: "Lampadati Tigon", price: 17000000 },
  { name: "Lampadati Tropos Rallye", price: 325000 },
  { name: "Lampadati Viseris", price: 1050000 },
  { name: "LCC Avarus", price: 100000 },
  { name: "LCC Hexer", price: 80000 },
  { name: "LCC Innovation", price: 167500 },
  { name: "LCC Sanctus", price: 175000 },
  { name: "Maibatsu Akuma", price: 275000 },
  { name: "Maibatsu Blazer Sport", price: 296250 },
  { name: "Maibatsu Itali GPB", price: 13500000 },
  { name: "Maibatsu Itali GTO", price: 1300000 },
  { name: "Maibatsu Itali GTO Stinger TT", price: 1190000 },
  { name: "Maibatsu Manchez", price: 41500 },
  { name: "Maibatsu Manchez Scout", price: 70000 },
  { name: "Maibatsu Manchez Scout Classic", price: 75000 },
  { name: "Maibatsu MonstroCiti", price: 240000 },
  { name: "Maibatsu Mule", price: 200000 },
  { name: "Maibatsu Mule (Heist)", price: 200000 },
  { name: "Maibatsu Mule XL", price: 400000 },
  { name: "Maibatsu Sanchez", price: 76500 },
  { name: "Maibatsu Sanchez Livery", price: 76500 },
  { name: "Mammoth Patriot Stretch", price: 475000 },
  { name: "Maxwell Asbo", price: 4000 },
  { name: "Maxwell Vagrant", price: 250000 },
  { name: "MTL Brickade", price: 600000 },
  { name: "MTL Brickade 6x6", price: 750000 },
  { name: "MTL Dune", price: 475000 },
  { name: "MTL Flatbed Truck", price: 325000 },
  { name: "MTL Packer", price: 500000 },
  { name: "MTL Pounder", price: 275000 },
  { name: "MTL Wastelander", price: 350000 },
  { name: "Nagasaki BF400", price: 110000 },
  { name: "Nagasaki Blazer Hot Rod", price: 235000 },
  { name: "Nagasaki Caddy (Civilian)", price: 150000 },
  { name: "Nagasaki Caddy (Golf)", price: 150000 },
  { name: "Nagasaki Carbon RS", price: 110000 },
  { name: "Nagasaki Chimera", price: 105000 },
  { name: "Nagasaki Outlaw", price: 75000 },
  { name: "Nagasaki Shinobi", price: 350000 },
  { name: "Nagasaki Shotaro", price: 1600000 },
  { name: "Nagasaki Stryder", price: 250000 },
  { name: "Obey 10F", price: 925000 },
  { name: "Obey 10F Widebody", price: 1075000 },
  { name: "Obey 9F", price: 475000 },
  { name: "Obey 9F Cabrio", price: 525000 },
  { name: "Obey Omnis e-GT", price: 925000 },
  { name: "Obey Rocoto", price: 65000 },
  { name: "Obey Tailgater S", price: 750000 },
  { name: "Ocelot Ardent", price: 150000 },
  { name: "Ocelot F620", price: 162500 },
  { name: "Ocelot Jackal", price: 145000 },
  { name: "Ocelot Jugular", price: 3500000 },
  { name: "Ocelot Locust", price: 1000000 },
  { name: "Ocelot Lynx", price: 750000 },
  { name: "Ocelot Pariah", price: 450000 },
  { name: "Ocelot Penetrator", price: 11500000 },
  { name: "Ocelot R88", price: 1500000 },
  { name: "Ocelot Swinger", price: 1105000 },
  { name: "Ocelot Virtue", price: 4100000 },
  { name: "Ocelot XA-21", price: 14000000 },
  { name: "Överflöd Autarch", price: 16200000 },
  { name: "Överflöd Entity MT", price: 15000000 },
  { name: "Överflöd Entity XF", price: 14000000 },
  { name: "Överflöd Entity XXR", price: 13200000 },
  { name: "Överflöd Imorgon", price: 600000 },
  { name: "Överflöd Tyrant", price: 15500000 },
  { name: "Överflöd Zeno", price: 11750000 },
  { name: "Pegassi Bati 801", price: 120000 },
  { name: "Pegassi Bati 801RR", price: 95000 },
  { name: "Pegassi Faggio", price: 29500 },
  { name: "Pegassi Faggio Mod", price: 62500 },
  { name: "Pegassi Faggio Sport", price: 45000 },
  { name: "Pegassi FCR 1000", price: 75000 },
  { name: "Pegassi FCR 1000 Custom", price: 145000 },
  { name: "Pegassi Esskey", price: 60000 },
  { name: "Pegassi Ignus", price: 10600000 },
  { name: "Pegassi Infernus", price: 16750000 },
  { name: "Pegassi Infernus Classic", price: 1225000 },
  { name: "Pegassi Monroe", price: 575000 },
  { name: "Pegassi Osiris", price: 16000000 },
  { name: "Pegassi Reaper", price: 10000000 },
  { name: "Pegassi Ruffian", price: 125000 },
  { name: "Pegassi Shitzu Hakuchou Drag", price: 225000 },
  { name: "Pegassi Tempesta", price: 11000000 },
  { name: "Pegassi Tezeract", price: 16000000 },
  { name: "Pegassi Torero", price: 420000 },
  { name: "Pegassi Torero XO", price: 17250000 },
  { name: "Pegassi Toros", price: 325000 },
  { name: "Pegassi Vacca", price: 10250000 },
  { name: "Pegassi Vortex", price: 155000 },
  { name: "Pegassi Zentorno", price: 22000000 },
  { name: "Pegassi Zorrusso", price: 18850000 },
  { name: "Penaud La Coureuse", price: 995000 },
  { name: "Pfister 811", price: 16000000 },
  { name: "Pfister Astron", price: 1250000 },
  { name: "Pfister Comet", price: 650000 },
  { name: "Pfister Comet Retro Custom", price: 875000 },
  { name: "Pfister Comet S2", price: 1150000 },
  { name: "Pfister Comet Safari", price: 550000 },
  { name: "Pfister Comet SR", price: 775000 },
  { name: "Pfister Growler", price: 1025000 },
  { name: "Pfister Neon", price: 1100000 },
  { name: "Principe Diablous", price: 150000 },
  { name: "Principe Diablous Custom", price: 190000 },
  { name: "Principe Lectro", price: 140000 },
  { name: "Principe Nemesis", price: 100000 },
  { name: "Principe Deveste", price: 16700000 },
  { name: "Progen Emerus", price: 16000000 },
  { name: "Progen GP1", price: 10500000 },
  { name: "Progen Itali GPB", price: 13500000 },
  { name: "Progen Itali GTO", price: 1300000 },
  { name: "Progen Itali GTB", price: 13500000 },
  { name: "Progen Itali GTB Custom", price: 17500000 },
  { name: "Progen Itali RSX", price: 7500000 },
  { name: "Progen PR4", price: 1250000 },
  { name: "Progen T20", price: 13250000 },
  { name: "Progen Tyrus", price: 16500000 },
  { name: "Rune Cheburek", price: 35000 },
  { name: "S2 Cabrio Comet", price: 3000000 },
  { name: "Schyster Deviant", price: 350000 },
  { name: "Shitzu Defiler", price: 150000 },
  { name: "Shitzu Hakuchou", price: 85000 },
  { name: "Shitzu Hakuchou Drag", price: 225000 },
  { name: "Shitzu PCJ-600", price: 125000 },
  { name: "Shitzu Vader", price: 86000 },
  { name: "Stanley Fieldmaster", price: 150000 },
  { name: "Stanley Tractor", price: 150000 },
  { name: "Toundra Panthere", price: 475000 },
  { name: "Truffade Adder", price: 19000000 },
  { name: "Truffade Nero", price: 15000000 },
  { name: "Truffade Nero Custom", price: 18000000 },
  { name: "Truffade Thrax", price: 14000000 },
  { name: "Truffade Z-Type", price: 13500000 },
  { name: "Übermacht Cypher", price: 775000 },
  { name: "Übermacht Oracle", price: 110000 },
  { name: "Übermacht Oracle XS", price: 190000 },
  { name: "Übermacht Rebla GTS", price: 255000 },
  { name: "Übermacht Revolter", price: 475000 },
  { name: "Übermacht Rhinehart", price: 750000 },
  { name: "Übermacht SC1", price: 5000000 },
  { name: "Übermacht Sentinel", price: 150000 },
  { name: "Übermacht Sentinel Classic", price: 350000 },
  { name: "Übermacht Sentinel Classic Widebody", price: 700000 },
  { name: "Übermacht Sentinel XS", price: 165000 },
  { name: "Übermacht Zion", price: 140000 },
  { name: "Übermacht Zion Cabrio", price: 140000 },
  { name: "Übermacht Zion Classic", price: 225000 },
  { name: "Unknown Cable Car", price: 500000 },
  { name: "Unknown Festival Bus", price: 400000 },
  { name: "Unknown Freight Train", price: 500000 },
  { name: "Unknown Metro Train", price: 500000 },
  { name: "Unknown Trailer (Christmas)", price: 150000 },
  { name: "Unknown Trailer (TV)", price: 150000 },
  { name: "Vapid 73SRT", price: 230000 },
  { name: "Vapid Aleutian", price: 917500 },
  { name: "Vapid Benson", price: 275000 },
  { name: "Vapid Benson (Cluckin Bell)", price: 250000 },
  { name: "Vapid Bobcat XL Open", price: 117500 },
  { name: "Vapid Boxville Go Postal", price: 225000 },
  { name: "Vapid Boxville Humane Labs", price: 225000 },
  { name: "Vapid Boxville LSDWP", price: 225000 },
  { name: "Vapid Boxville Post OP", price: 225000 },
  { name: "Vapid Brawler", price: 200000 },
  { name: "Vapid Bullet", price: 11000000 },
  { name: "Vapid cadlegend", price: 1250000 },
  { name: "Vapid chevy4d71", price: 1400000 },
  { name: "Vapid Chino", price: 75000 },
  { name: "Vapid Chino Luxe", price: 125000 },
  { name: "Vapid Classic Gauntlet", price: 375000 },
  { name: "Vapid Clique Wagon", price: 512500 },
  { name: "Vapid Contender", price: 175000 },
  { name: "Vapid Desert Raid", price: 400000 },
  { name: "Vapid Dominator", price: 312500 },
  { name: "Vapid Dominator ASP", price: 550000 },
  { name: "Vapid Dominator GTX", price: 350000 },
  { name: "Vapid Dominator GTT", price: 400000 },
  { name: "Vapid Ellie", price: 211250 },
  { name: "Vapid Flash GT", price: 390000 },
  { name: "Vapid FMJ", price: 11250000 },
  { name: "Vapid GB 200", price: 700000 },
  { name: "Vapid Guardian", price: 425000 },
  { name: "Vapid Hotknife", price: 450000 },
  { name: "Vapid Hustler", price: 475000 },
  { name: "Vapid Lost Slam Van", price: 450000 },
  { name: "Vapid Minivan", price: 135000 },
  { name: "Vapid Minivan Custom", price: 100000 },
  { name: "Vapid Mule", price: 200000 },
  { name: "Vapid Mule (Heist)", price: 200000 },
  { name: "Vapid Mule XL", price: 400000 },
  { name: "Vapid Peyote", price: 117500 },
  { name: "Vapid Peyote Custom", price: 240000 },
  { name: "Vapid Peyote Gasser", price: 200000 },
  { name: "Vapid Phantom (Christmas)", price: 500000 },
  { name: "Vapid Pony (Smoke on the water)", price: 225000 },
  { name: "Vapid Radius", price: 90000 },
  { name: "Vapid Ratel", price: 995000 },
  { name: "Vapid Rebel", price: 100000 },
  { name: "Vapid Retinue", price: 160000 },
  { name: "Vapid Retinue MKII", price: 190000 },
  { name: "Vapid Riata", price: 1900000 },
  { name: "Vapid Sadler", price: 100000 },
  { name: "Vapid Sandking SWB", price: 190000 },
  { name: "Vapid Sandking XL", price: 125000 },
  { name: "Vapid Scrap Truck", price: 150000 },
  { name: "Vapid Slam Truck", price: 500000 },
  { name: "Vapid Slam Van", price: 150000 },
  { name: "Vapid Slam Van Custom", price: 85000 },
  { name: "Vapid Speedo", price: 100000 },
  { name: "Vapid Speedo Custom", price: 1190000 },
  { name: "Vapid Stanier", price: 95000 },
  { name: "Vapid Taxi", price: 200000 },
  { name: "Vapid Tow Truck (Large)", price: 150000 },
  { name: "Vapid Tow Truck (Small)", price: 150000 },
  { name: "Vapid Trophy Truck", price: 300000 },
  { name: "Vapid Utility Truck (Contender)", price: 150000 },
  { name: "Vapid Winky", price: 50000 },
  { name: "Vysser Neo", price: 1150000 },
  { name: "Vulcar Fagaloa", price: 65000 },
  { name: "Vulcar Ingot", price: 74995 },
  { name: "Vulcar Nebula", price: 110000 },
  { name: "Vulcar Warrener", price: 70000 },
  { name: "Vulcar Warrener HKR", price: 150000 },
  { name: "Weeny Dynasty", price: 125000 },
  { name: "Weeny Issi", price: 85000 },
  { name: "Weeny Issi Classic", price: 75000 },
  { name: "Weeny Issi Rally", price: 250000 },
  { name: "Weeny Issi Sport", price: 500000 },
  { name: "Western Bagger", price: 67500 },
  { name: "Western Cliffhanger", price: 142500 },
  { name: "Western Daemon Custom", price: 115000 },
  { name: "Western Powersurge", price: 85000 },
  { name: "Western Rat Bike", price: 65000 },
  { name: "Western Reever", price: 125000 },
  { name: "Western Wolfsbane", price: 70000 },
  { name: "Western Zombie Chopper", price: 135000 },
  { name: "Western Zombie Bobber", price: 140000 },
  { name: "Willard Eudora", price: 85000 },
  { name: "Willard Faction", price: 100000 },
  { name: "Willard Faction Custom Donk", price: 175000 },
  { name: "Willard Faction Rider", price: 150000 },
  { name: "WMC Bagger", price: 67500 },
  { name: "WMC Daemon", price: 70000 },
  { name: "WMC Nightblade", price: 115000 },
  { name: "WMC Sovereign", price: 90000 },
  { name: "Wow Omnis", price: 450000 },
  { name: "Zirconium Journey", price: 35000 },
  { name: "Zirconium Journey II", price: 132500 },
  { name: "Zirconium Stratum", price: 75000 },
];
